module.exports = __webpack_public_path__ + "assets/img/811587017478_.pic_hd.32c38e5b.jpg";